import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET, API_METHOD_POST } from "../../config/constants";
import CoreDataTable from "../../core/dataDisplay/datatable/CoreDataTable";
import { Box, Icon } from "@mui/material";
import {
  DELETE_GROUPS_ERROR,
  DELETE_GROUPS_SUCCESS,
  FETCH_DOC_USERS_ERROR,
  FETCH_DOC_USERS_SUCCESS,
  GROUP_DATA_ERROR,
  GROUP_DATA_SUCCESS,
} from "../../store/types/billTypes";
import { useLocation, useNavigate } from "react-router";
import CoreH6 from "../../core/dataDisplay/CoreH6";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import {
  downloadHofPdf,
  setBillReducer,
} from "../../store/actions/billActions";
import CoreDataTableDashboard from "../../core/dataDisplay/datatable/CoreDataTableDashboard";
import Card1 from "../../core/layouts/Card1";

export default function ToolDashboard() {
  const users = useSelector((state) => state.bill.userDocs);
  const user = useSelector((state) => state.auth.user);
  const groupDocsSuccess = useSelector((state) => state.bill.groupDocsSuccess);
  const groupDocsError = useSelector((state) => state.bill.groupDocsError);
  const deleteGroupSuccess = useSelector(
    (state) => state.bill.deleteGroupSuccess,
  );
  const deleteGroupError = useSelector((state) => state.bill.deleteGroupError);
  const tools = useSelector((state) => state.common.tools);
  const location = useLocation();

  const tool = location.pathname.split("/")[1];
  const toolMeta = tools?.find((t) => t.name === tool)?.extraInfo?.dashboard;

  const [open, setModal] = useState(false);
  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setModal(false);
    getData();
    dispatch(
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false }),
    );
  }, []);

  useEffect(() => {
    if (users && users.length) {
      let cols = users[0] ? Object.keys(users[0]?.info?.criteria) : [];
      cols = cols?.map((col) => {
        console.log("COL ", typeof users[0]?.info?.criteria[col]);
        return {
          name: col,
          isBoolean: typeof users[0]?.info?.criteria[col] === "boolean",
        };
      });

      setColumns(cols);
    }
  }, [users]);

  useEffect(() => {
    if (groupDocsSuccess) {
      getData();
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
    if (groupDocsError) {
      alert("Internal error");
      setBillReducer({ groupDocsSuccess: false, groupDocsError: false });
    }
  }, [groupDocsSuccess, groupDocsError]);

  useEffect(() => {
    if (deleteGroupSuccess) {
      getData();
      setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false });
    }
    if (deleteGroupError) {
      alert("Internal error");
      setBillReducer({ deleteGroupSuccess: false, deleteGroupError: false });
    }
  }, [deleteGroupSuccess, deleteGroupError]);

  const getData = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/DocGroups",
        {},
        {
          _defaultFilter: encodeURIComponent(
            JSON.stringify({ userId: user.id, tool, type: "basic" }),
          ),
        },
        null,
        FETCH_DOC_USERS_SUCCESS,
        FETCH_DOC_USERS_ERROR,
        true,
        false,
      ),
    );
  };

  const viewDocs = (row) => {
    navigate("/" + tool + "/docs/view", {
      state: { docGroupId: row.id, label: row.fieldValue },
    });
  };

  const groupData = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/group/documents",
        {},
        {},
        null,
        GROUP_DATA_SUCCESS,
        GROUP_DATA_ERROR,
        true,
        false,
      ),
    );
  };

  const downloadPdf = (row) => {
    console.log("Downloading pdf for ", row);
    dispatch(downloadHofPdf(row.id));
  };

  const deleteGroups = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/groups/delete/all",
        {},
        {},
        null,
        DELETE_GROUPS_SUCCESS,
        DELETE_GROUPS_ERROR,
        true,
        false,
        true,
      ),
    );
  };

  console.log("cols ", tools, toolMeta);

  return (
    <Box style={{ width: "100%", height: "calc(100vh - 96px)" }}>
      <Box
        style={{
          padding: 16,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Card1
          title={toolMeta?.headline || "Document Users"}
          style={{
            backgroundColor: "white",
            textAlign: "left",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: -40,
            }}
          >
            <CoreIconButton onClick={deleteGroups}>
              <Icon>delete_all</Icon>
            </CoreIconButton>
            <CoreIconButton onClick={groupData}>
              <Icon>sync</Icon>
            </CoreIconButton>
          </Box>
          <Box style={{ flex: 1, overflowY: "auto", marginTop: 16 }}>
            {columns && columns?.length > 0 && (
              <CoreDataTableDashboard
                showToolbar={false}
                selectable={false}
                noOfRows={10}
                rowActions={
                  tool === "hof-extraction"
                    ? [
                        {
                          title: "View",
                          icon: "chevron_right",
                          onClick: viewDocs,
                        },
                        {
                          title: "Download",
                          icon: "download",
                          onClick: downloadPdf,
                        },
                      ]
                    : [
                        {
                          title: "View",
                          icon: "chevron_right",
                          onClick: viewDocs,
                        },
                      ]
                }
                columns={[
                  {
                    view: (row) => {
                      return row.fieldValue;
                    },
                    name: "name",
                    label: toolMeta?.name || "Name",
                    width: "40%",
                  },
                  ...(columns?.map((col) => {
                    return {
                      view: (row) => {
                        if (row.info?.criteria) {
                          if (col.isBoolean) {
                            if (row.info.criteria[col.name]) {
                              return <Icon color="success">check_circle</Icon>;
                            } else {
                              return <Icon color="error">cancel</Icon>;
                            }
                          } else if (row.info?.criteria[col.name]) {
                            try {
                              let x = Number(row.info?.criteria[col.name]);
                              if (isNaN(x)) {
                                return (
                                  row.info?.criteria[
                                    col.name
                                  ][0].toUpperCase() +
                                  row.info?.criteria[col.name].slice(1)
                                );
                              } else {
                                return x.toFixed(2);
                              }
                            } catch (err) {
                              return (
                                row.info?.criteria[col.name][0].toUpperCase() +
                                row.info?.criteria[col.name].slice(1)
                              );
                            }
                          } else return null;
                        }
                      },
                      name: col.name,
                      label: col.name,
                      width: "20%",
                    };
                  }) || []),
                ]}
                rows={users || []}
              />
            )}
          </Box>
        </Card1>
      </Box>
    </Box>
  );
}
